var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.speaker
    ? _c(
        "a",
        {
          staticClass:
            "speaker-card w-100 h-100 text-decoration-none text-dark",
          attrs: { href: _vm.route("nl.speaker", { slug: _vm.speaker.slug }) }
        },
        [
          _c(
            "div",
            {
              staticClass: "image-wrapper",
              style: {
                "padding-top": _vm.ratio
                  ? (_vm.arHeight / _vm.arWidth) * 100 + "%"
                  : "240px"
              }
            },
            [
              _vm.speaker.acf && _vm.speaker.acf.image
                ? _c("img", {
                    staticClass: "w-100",
                    attrs: {
                      src: _vm.speaker.acf.image.sizes.large,
                      alt: _vm.speaker.title.rendered
                    }
                  })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass: "mb-0 mt-8 small",
            domProps: { innerHTML: _vm._s(_vm.speaker.title.rendered) }
          }),
          _vm._v(" "),
          _vm.speaker.acf && _vm.speaker.acf.bullet_points
            ? _vm._l(_vm.speaker.acf.bullet_points, function(
                bulletPoint,
                index
              ) {
                return _c("p", { key: index, staticClass: "xsmall" }, [
                  _vm._v(_vm._s(bulletPoint.bullet_point))
                ])
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }